(() => {
  // Wer mit der Maus auf einer Produktkarte verweilt, klickt meist. Dann wird das erste
  // Galeriebild der Produktseite schon jetzt geladen — mit denselben Breiten und sizes wie
  // dort, damit der Browser dieselbe Datei wählt und sie nach dem Klick aus dem Cache nimmt.
  // Nur für Maus und Tastatur: auf dem Handy würde jedes Wischen über eine Karte zählen.
  const script = document.currentScript;
  const widths = (script?.dataset.widths || '').split(',').map(width => width.trim()).filter(Boolean);
  const sizes = script?.dataset.sizes || '';
  const hoverDelay = 80;
  const maxWarm = 12;
  const linkSelector = 'a[href*="/products/"]';
  const connection = navigator.connection;
  if (!widths.length || !sizes) return;
  if (connection?.saveData || /2g/.test(connection?.effectiveType || '')) return;

  // Die Bilder brauchen eine Referenz, sonst darf der Browser den Ladevorgang verwerfen.
  const warmed = new Map();
  let timer = 0;
  let pending = null;

  function warm(link) {
    const base = link.closest('[data-fs-pdp-image]')?.dataset.fsPdpImage;
    if (!base || warmed.has(base) || warmed.size >= maxWarm) return;
    const image = new Image();
    image.decoding = 'async';
    // sizes vor srcset, sonst wählt der Browser einmal kurz mit 100vw.
    image.sizes = sizes;
    image.srcset = widths.map(width => `${base}&width=${width} ${width}w`).join(', ');
    warmed.set(base, image);
  }

  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const link = event.target.closest?.(linkSelector);
    if (!link || link === pending) return;
    clearTimeout(timer);
    pending = link;
    timer = setTimeout(() => warm(link), hoverDelay);
  }, { passive: true });

  document.addEventListener('pointerout', event => {
    if (!pending || pending.contains(event.relatedTarget)) return;
    clearTimeout(timer);
    pending = null;
  }, { passive: true });

  // Maustaste gedrückt heißt: der Klick kommt gleich — nicht erst die Verweilzeit abwarten.
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse') return;
    const link = event.target.closest?.(linkSelector);
    if (link) warm(link);
  }, { passive: true });

  document.addEventListener('focusin', event => {
    const link = event.target.closest?.(linkSelector);
    if (link) warm(link);
  });
})();
